import { Subject } from 'rxjs';
import { INotification } from '../interfaces/notification.interface';

export const notificationListener = new Subject<INotification>();
